export const GET_PLATFORMS_SUCCESS = 'GET_PLATFORMS_SUCCESS';
export const GET_PLATFORMS_FAILURE = 'GET_PLATFORMS_FAILURE';
export const APPROVE_PLATFORM_SUCCESS = 'APPROVE_PLATFORM_SUCCESS';
export const APPROVE_PLATFORM_FAILURE = 'APPROVE_PLATFORM_FAILURE';
export const REJECT_PLATFORM_SUCCESS = 'REJECT_PLATFORM_SUCCESS';
export const REJECT_PLATFORM_FAILURE = 'REJECT_PLATFORM_FAILURE';
